import { render, staticRenderFns } from "./LabeledInput.vue?vue&type=template&id=33398047&"
import script from "./LabeledInput.vue?vue&type=script&lang=ts&"
export * from "./LabeledInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports